import { Badge, Icon } from '../components/primitives';

// Screens wired to live data in their phases. Until then, a clean "coming next" stub
// so navigation works and the shell is fully browsable.
export const Placeholder = ({
  title,
  phase,
  blurb,
}: {
  title: string;
  phase: string;
  blurb: string;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        padding: 32,
      }}
    >
      <div
        className="hf-glass"
        style={{
          maxWidth: 460,
          textAlign: 'center',
          padding: '40px 36px',
          borderRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: 'var(--hf-accent-wash)',
            border: '1px solid var(--hf-accent-line)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--hf-accent)',
          }}
        >
          <Icon name="layers" size={22} />
        </div>
        <div
          style={{
            fontFamily: 'var(--hf-font-display)',
            fontSize: 22,
            fontWeight: 400,
            letterSpacing: '-0.02em',
          }}
        >
          {title}
        </div>
        <Badge tone="accent">{phase}</Badge>
        <p style={{ color: 'var(--hf-ink-2)', fontSize: 13, lineHeight: 1.6, margin: 0 }}>
          {blurb}
        </p>
      </div>
    </div>
  );
};
